import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

import developmentConfig from "./firebase.development.config.json";
import productionConfig from "./firebase.production.config.json";

const config = (() => {
  switch (import.meta.env.VITE_FIREBASE_STAGE) {
    case "development":
      return developmentConfig;
    case "production":
      return productionConfig;
    default:
      return developmentConfig;
  }
})();

export const app = initializeApp(config);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app, "europe-west3");
export const storage = getStorage(app);

// Connect to emulators in development
if (import.meta.env.VITE_EMULATED) {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(firestore, "localhost", 8081);
  connectFunctionsEmulator(functions, "localhost", 5001);
}
